import { createSlice } from "@reduxjs/toolkit"
import BODY_MAIL_TYPES from "../pages/admin/mailer/bodyMailTypes"
import BODY_LANGUAGE_TYPES from "../pages/admin/mailer/bodyLanguageTypes"

export const buttons = [
  "undo",
  "redo",
  "|",
  "bold",
  "strikethrough",
  "underline",
  "italic",
  "|",
  "align",
  "|",
  "ul",
  "ol",
  "outdent",
  "indent",
  "|",
  "font",
  "fontsize",
  "brush",
  "paragraph",
  "|",
  "link",
  "table",
  "|",
  "image",
  "|",
  "source"
]
const DEFAULT_CONFIG = {
  readonly: false,
  toolbar: true,
  spellcheck: true,
  language: "fr",
  toolbarButtonSize: "medium",
  toolbarAdaptive: false,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: false,
  askBeforePasteHTML: true,
  askBeforePasteFromWord: true,
  buttons
}
const initialState = {
  typeBody: BODY_MAIL_TYPES.invite,
  listVariable: [],
  checked: false,
  typeLanguage: BODY_LANGUAGE_TYPES.fr,
  dialogIsShowing: false,
  templateTest: {},
  configEditor: DEFAULT_CONFIG,
  content: "",
  contentTmp: ""
}
const templateSlice = createSlice({
  name: "smtpForm",
  initialState,
  reducers: {
    setTypeBody: (state, { payload }) => ({
      ...state,
      typeBody: payload
    }),
    setListVariable: (state, { payload }) => ({
      ...state,
      listVariable: payload
    }),
    setChecked: (state, { payload }) => ({
      ...state,
      checked: payload
    }),
    setTypeLanguage: (state, { payload }) => ({
      ...state,
      typeLanguage: payload
    }),
    setDialogIsShowing: (state, { payload }) => ({
      ...state,
      dialogIsShowing: payload
    }),
    setTemplateTest: (state, { payload }) => ({
      ...state,
      templateTest: payload
    }),
    setConfigEditor: (state, { payload }) => ({
      ...state,
      configEditor: payload
    }),
    setContent: (state, { payload }) => ({
      ...state,
      content: payload
    }),
    setContentTmp: (state, { payload }) => ({
      ...state,
      contentTmp: payload
    })
  }
})
export default {
  initialState,
  actions: {
    ...templateSlice.actions
  },
  reducer: templateSlice.reducer
}
